<div class="col-md-12 info-register" style="background-color: {{corFundo}}">
  <img class="logo-register" src="assets/{{logo}}" alt="Logo">
  <div class="textos-info">
    Junte-se a <b>centenas</b> de {{publicoAlvo}} e descubra uma nova forma de atuar.
  </div>
  <div class="imagem">
    <img src="assets/{{imagem}}" alt="{{publicoAlvo}}" class="img-fluid">
  </div>

  <div class="textos-titulo">
    {{titulo}}
  </div>
  <div class="textos-centralizados" >
    <i class="fa fa-check-circle-o" style="color: {{color}}"></i> Gestão de processos ágil, organizada e produtiva
  </div>
  <div class="textos-centralizados">
    <i class="fa fa-check-circle-o" style="color: {{color}}"></i> Automação de tarefas junto com a IA
  </div>
  <div class="textos-centralizados">
    <i class="fa fa-check-circle-o" style="color: {{color}}"></i> Armazenamento de documentos seguro
  </div>
</div>
